(function(){
  function isMobile(){
    return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function openModal(){
    var overlay=document.getElementById('contact-modal-overlay');
    var modal=document.getElementById('contact-modal');
    if(!overlay||!modal) return;
    overlay.classList.add('active');
    modal.classList.add('active');
    var mobilePane=document.getElementById('cm-mobile');
    var desktopPane=document.getElementById('cm-desktop');
    if(isMobile()){ mobilePane&&(mobilePane.style.display='block'); desktopPane&&(desktopPane.style.display='none'); }
    else { mobilePane&&(mobilePane.style.display='none'); desktopPane&&(desktopPane.style.display='block'); }
    // focus trap
    modal.setAttribute('tabindex','-1');
    modal.focus();
  }

  function closeModal(){
    var overlay=document.getElementById('contact-modal-overlay');
    var modal=document.getElementById('contact-modal');
    overlay&&overlay.classList.remove('active');
    modal&&modal.classList.remove('active');
  }

  function wireTriggers(){
    var selectors=['.open-contact-modal','.contact-us','.local-pickup-btn','[data-open="contact-modal"]'];
    var nodes=document.querySelectorAll(selectors.join(','));
    nodes.forEach(function(n){ n.addEventListener('click',function(e){ e.preventDefault(); openModal(); }); });
  }

  function wireClose(){
    var overlay=document.getElementById('contact-modal-overlay');
    var modal=document.getElementById('contact-modal');
    var closeBtn=modal?modal.querySelector('.cm-close'):null;
    overlay&&overlay.addEventListener('click',closeModal);
    closeBtn&&closeBtn.addEventListener('click',closeModal);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeModal(); });
  }

  function wireForm(){
    var form=document.getElementById('cm-whatsapp-form');
    if(!form) return;
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var name=(document.getElementById('cm-name')||{}).value||'';
      var message=(document.getElementById('cm-message')||{}).value||'';
      if(!name.trim()||!message.trim()){ alert('Please fill in all fields'); return; }
      var text='Hello! My name is '+name+"\n\nQuestion: "+message+"\n\nWebsite: zoo38.shop";
      var phone='+447389878384';
      var url='whatsapp://send?phone='+encodeURIComponent(phone)+'&text='+encodeURIComponent(text);
      window.open(url);
      closeModal();
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    wireTriggers();
    wireClose();
    wireForm();
    // expose for manual open if needed
    window.openContactModal=openModal;
  });
})();


